import React from 'react';
import PolicyFooter from './policy-footer';

export default class SitePolicy extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <div className="main-contents">
                    <div className={`site-policy-flex ${this.props.className ?? ''}`}>
                        <h1 className="bb-1px-solid">サイトポリシー</h1>
                        <h2 className="bb-1px-solid">1.はじめに</h2>
                        <div className="info-group">
                            <p>このウェブサイト（以下「当サイト」）株式会社魚国総本社が運営しております。</p>
                            <p>お客様が当サイトをご利用されるにあたっては、以下の利用規約をお読み頂き、同意される場合にのみご利用下さい。</p>
                            <p>なお、本規約につきましては予告なく変更することがありますので、あらかじめ御了承下さい。</p>
                        </div>
                        <h2 className="bb-1px-solid">2.免責事項</h2>
                        <div className="info-group">
                            <p>当社は、当サイトに掲載されている全ての情報を慎重に作成し、また管理しますが、その正確性および完全性などに関して、いかなる保証もするものではありません。</p>
                            <p>また、予告なしに、当サイトの運営を停止または中止し、また当サイトに掲載されている情報の全部または一部を変更する場合があります。</p>
                            <p>利用者が当サイトを利用したこと、または何らかの原因によりこれをご利用できなかったことにより生じる一切の損害および第三者によるデータの書き込み、不正なアクセス、発言、メールの送信等に関して生じる一切の損害について、当社は、何ら責任を負うものではありません。</p>
                        </div>
                        <h2 className="bb-1px-solid">3.著作権</h2>
                        <div className="info-group">
                            <p>当サイト上に掲載されている情報（文章・ロゴ・商標・商号・写真・イラスト・データ等を含む）の著作権その他の知的財産権は、当社または当社に使用を認めた権利者に帰属し著作権法およびその他の法律によって保護されています。</p>
                            <p>当サイト上に掲載されている全ての情報については、当社の事前の承諾が無い限り、複製・改変をはじめ、第三者への転送、営利目的での使用（販売、実演、貸与）、著作権その他の知的財産権表示の除去を行うことを禁止します。</p>
                        </div>
                        <h2 className="bb-1px-solid">4.リンクについて</h2>
                        <div className="info-group">
                            <p>当社は、当サイトからリンクしている他のサイトのコンテンツに関しまして、一切の責任を負いません。</p>
                            <p>また、当サイトへリンクされる場合は、リンク元のサイトの運営主体、リンクの目的およびリンク元のページのURL などを、事前に当社へご連絡ください。</p>
                            <p>なお、内容によってはリンクをお断りすることがありますのでご了承ください。</p>
                        </div>
                        <h2 className="bb-1px-solid">5.特定原材料（アレルギー）表示について</h2>
                        <div className="info-group">
                            <p>当サイトでは、特定原材料（アレルギー）の表示について以下の対応を行っております。お食事を選ばれる際のご参考としてご確認ください。</p>
                            <p className="topic">・特定原材料（8品目：卵・乳・小麦・そば・落花生・かに・えび　および　4品目：牛肉・大豆・鶏肉・豚肉））を入手可能な範囲で表示しています。</p>
                            <p className="topic">・すべての食材は同一の厨房・調理機器で取り扱っております。意図せぬ混入(コンタミネーション)を完全に防ぐことはできません。</p>
                            <p className="topic">・仕入れ状況により、使用食材が予告なく変更となる場合があります。</p>
                            <p className="topic">・お召し上がりの際は、表示内容をご確認のうえ、お客様ご自身でご判断いただきますようお願い申し上げます。</p>
                        </div>
                        <h2 className="bb-1px-solid">6.閲覧環境について</h2>
                        <div className="info-group">
                            <p>当サイトは、Microsoft Edge、Safari、Chrome でのご利用を推奨しております。</p>
                            <p>その他の環境での閲覧については、情報が欠落したり体裁が崩れたりしないよう努めておりますが、完全な状態でコンテンツを閲覧できない事象が発生する可能性がありますのでご了承ください。</p>
                            <p>生じる一切の損害について、当社は、何ら責任を負うものではありません。</p>
                        </div>
                        <h2 className="bb-1px-solid">6.Cookies（クッキー）の使用について</h2>
                        <div className="info-group">
                            <p>当サイトでは、一部のページでクッキー(Cookies)の仕組みを利用して、お客様が毎回入力する手間を省いたり、お客様が訪れたページの履歴情報などを収集することがあります。</p>
                            <p>クッキー(Cookies)によってお客様の個人情報を取得することはありません。</p>
                            <p>またお客様はクッキー(Cookies) の受取を拒否することができます。</p>
                            <p>この場合、当サイトが提供するサービスを一部ご利用できない場合があります。</p>
                        </div>
                    </div>
                    <PolicyFooter/>
                </div>
            </React.Fragment>
        );
    }
}